export enum InactivityDialogSelection {
	SignOutNow = 'Sign Out Now',
	RemainSignedIn = 'Remain Signed In'
}
